import styled from 'styled-components'
import Button from './button'
import { when } from '../../../utils/mixin'

const ButtonGroup = styled.div<{
  horizontal?: boolean
  vertical?: boolean
  css?: any
}>`
  ${({ css }) => css}
  ${Button} + ${Button} {
    ${when('horizontal')(`
      margin-left: 16px;
    `)}
    ${when('vertical')(`
      margin-top: 16px;
    `)}
  }
  ${when('vertical')(`
    ${Button} {
      width: 100%;
    }
  `)}
`

export default ButtonGroup



// WEBPACK FOOTER //
// ./src/components/atoms/button/button-group.tsx